import * as React from "react";
import { Button } from "@/components/Shared";

interface DealsNotFoundProps {
	clearFilters: () => void;
}

const DealsNotFound: React.FC<DealsNotFoundProps> = ({ clearFilters }) => {
	const onClick = () => {
		clearFilters();
	};

	return (
		<>
			<div className="text-center">
				<p>No deals were found matching your search criteria.</p>
				<Button
					title="Reset Filters"
					name="reset"
					type="button"
					onClick={onClick}
				/>
			</div>
		</>
	);
};

export default DealsNotFound;
